<template>
    <tr v-bind:class="{ expired: expire }">
        <td scope="row"></td>
        <td>
            <a :href="getUrl">{{
                getPid
            }}</a>
        </td>
        <td>{{ getTitle }}</td>
        <td class="left">{{ getCapacity }}</td>
        <td v-if="record">{{ getWatt }}</td>
        <td v-else>-</td>
        <td v-if="record">{{ getToday }}</td>
        <td v-else>-</td>
        <td v-if="record">{{ getEfficient }}</td>
        <td v-else>-</td>
        <td v-if="record">{{ getTotal() }}</td>
        <td v-else>-</td>
        <td>{{ getDays() }}</td>
        <td v-if="record">{{ getAverageEfficient() }}</td>
        <td v-else>-</td>
        <td>{{ getDate }}</td>
        <td>{{ getCountdown() }}</td>
        <td></td>
    </tr>
</template>

<script>
import moment from "moment";

export default {
    name: "mix",
    props: ["project"],
    data() {
        return {
            info: this.project,
            record: this.project.latest_record,
            expire: false,
            days: 1,
        };
    },
    methods: {
        getTotal() {
            return this.record.total + this.getCorrectValue();
        },
        getDays() {
            this.days = moment().diff(moment(this.info.date), "days");
            return this.days + " 天";
        },
        getAverageEfficient() {
            return (this.getTotal() / this.days / this.info.capacity).toFixed(2);
        },
        getCountdown() {
            let day = moment(this.info.expiration_date).diff(moment(), "days") + 1;
            if (day <= 45) {
                this.expire = true;
            }

            return day + " 天";
        },
        getCorrectValue() {
            let logs = this.info.logs
            let sum = 0

            logs.forEach(log => {
                sum += log.value;
            });

            return sum;
        }
    },
    computed: {
        getUrl() {
            return "https://solars.hcge.com.tw/main/" + this.info.sn;
        },
        getPid() {
            return this.info.sn.substr(4);
        },
        getTitle() {
            return this.info.location.location.substr(0, 2) + this.info.name;
        },
        getCapacity() {
            return this.info.capacity.toFixed(3);
        },
        getWatt() {
            return (this.record.watt_dc / 1000).toFixed(2) + " kw";
        },
        getToday() {
            return (this.record.today / 1000).toFixed(2) + " 度";
        },
        getEfficient() {
            return (this.record.today / 1000 / this.info.capacity).toFixed(2);
        },
        getDate() {
            return this.info.date;
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
